<template>
  <div>
    <div class="title-bar detail clearfix">
      <div class="module pull-left">
          {{ $t("user.resetPassword") }}
      </div>
      <div class="btn-group pull-right">
        <el-button type="primary" :plain="true" size="mini" @click="resetPassword('resetPasswordForm')">{{ $t("save") }}
        </el-button>
        <el-button :plain="true" size="mini" @click="cancelOperation()">{{ $t("cancel") }}
        </el-button>
      </div>
    </div>
    <div class="data-list detail">
      <div class="detail-header">
        <span>{{ $t("user.resetPassword") }}</span>
        <div class="detail-triangle"></div>
      </div>
      <div class="detail-content">
        <el-form class="detail-form" size="small" ref="resetPasswordForm" :model="newPassword" label-width="80px" :rules="rules" status-icon>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.email')" prop="email">
                <el-input type="text" v-model="userInfo.Email" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.name')" prop="name">
                <el-input type="text" v-model="userInfo.Name" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.password')" prop="password">
                 <div @keyup="handlekeyup($event)">
                <el-input type="password" v-model="newPassword.password" auto-complete="off"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.confirmPassword')" prop="confirmPassword">
                <div id="confirmpwd">
                <el-input type="password" v-model="newPassword.confirmPassword" auto-complete="off"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
  data() {
    var confirmPassword = (rule, value, callback) => {
      if (value !== this.newPassword.password) {
        callback(new Error(this.$t("user.confirmPasswordSameValidation")));
      } else {
        callback();
      }
    };
      
    return {
      userInfo: {},
      newPassword: {
        password: "",
        confirmPassword: "",
        userId: this.$route.params.userId
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t("user.passwordValidation")
          },
          {
            min: 6,
            message: this.$t("user.pvalid.minLen", { len: 6 }),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[A-Z]/),
            message: this.$t("user.pvalid.oneUppercase"),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[a-z]/),
            message: this.$t("user.pvalid.oneLowercase"),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[0-9]/),
            message: this.$t("user.pvalid.oneDigit"),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[^a-zA-Z0-9]/),
            message: this.$t("user.pvalid.oneNonLetterOrDigit"),
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t("user.confirmPasswordRequiredValidation")
          },
          { validator: confirmPassword, trigger: "blur change" }
        ]
      }
    };
  },
  methods: {

     handlekeyup(event)
          {            
            var father=event.currentTarget;
            var confirm= document.getElementById("confirmpwd").getElementsByTagName("input")[0];
            var obj=father.getElementsByTagName("input")[0];          
            if(obj.value===this.newPassword.confirmPassword)
            {
               confirm.focus();
               obj.focus();
            }
                
        },
    resetPassword(resetPasswordForm) {
      this.$refs[resetPasswordForm].validate(valid => {
        if (valid) {
          this.$axios
            .post("api/users/resetPassword", this.newPassword)
            .then(response => {
              this.$message({
                message: this.$t("user.passwordResetSuccessfully"),
                type: "success",
                showClose: true,
                duration: 2000
              });
              this.$router.push({ name: "UserManagement" });
            })
            .catch(e => {
              let modelState = e.response && e.response.data.ModelState;
              let msg =
                (modelState && Object.values(modelState).join()) ||
                this.$t("user.operationFailure");
              this.$message({
                message: msg,
                type: "error"
              });
            });
        } else {
          return false;
        }
      });
    },
    cancelOperation() {
      this.$router.push({ name: "UserManagement" });
    }
  },
  created() {
    this.$axios.get(`api/users/${this.$route.params.userId}`).then(response => {
      this.userInfo = response.data;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/application/UserManagement/ResetPassword.vue